import { Outlet, Navigate, useSearchParams } from 'react-router-dom';
import { useGlobalStore } from '@digiwedge/global-state';

export default function PublicOnly() {
  const token = useGlobalStore((s) => s.token);
  const bypass = String(import.meta.env.VITE_BYPASS_AUTH ?? '') === '1';
  const [params] = useSearchParams();

  if (token && !bypass) {
    let target = params.get('redirectTo') ?? '';
    if (!target) {
      try {
        target = localStorage.getItem('cmp.portal.lastRoute') || '';
      } catch {
        target = '';
      }
    }
    if (!target) target = '/sites';
    return <Navigate to={target} replace />;
  }
  return <Outlet />;
}
